module.exports = __webpack_public_path__ + "img/1608885626610.a1f38a8d.png";